angular.module('eStories.server.notifications.model', [
    /*eStories Account Module*/
]).service('ServerNotificationsModel', ['WS', '$rootScope', 'AccountModel', function (WS, $rootScope, AccountModel) {
    var model = this;

    model.stopServerNotificationsInterval = function () {
        if (model.serverNotificationsInterval == null) {
            return;
        }
        clearInterval(model.serverNotificationsInterval);
        model.serverNotificationsInterval = null;
    };

    model.startServerNotificationsInterval = function () {
        model.stopServerNotificationsInterval();

        model.getNotificationList().then();
        model.serverNotificationsInterval = setInterval(function () {
            model.getNotificationList().then();
        }, 15000);
    };

    model.getNotificationList = async () => {
        const response = await WS.callServer('account/getNotificationList', {});
        if (response.responseStatus !== "SUCCESS") {
            if (response.responseText === "NO_SESSION") {
                $rootScope.$broadcast('successfulSignOut');
            }
            return;
        }
        if (!response.notificationList.length) {
            return;
        }

        for (let i = 0; i < response.notificationList.length; i++) {
            const notification = response.notificationList[i];
            const notificationType = notification.notificationType;
            $rootScope.$broadcast('NOTIFICATION_' + notificationType, notification);
        }
    };

    model.initServerNotificationsModel = function () {
        $rootScope.$on("successfulSignIn", function () {
            model.startServerNotificationsInterval();
        });

        $rootScope.$on("successfulSignOut", function () {
            model.stopServerNotificationsInterval();
        });
    };


}]);

